// @owners { team: patient-health }

import { SIZES } from '@alto/design-library-tokens';
import { Row, SizedImage } from '@alto/design-system';
import React from 'react';

export const ReminderImage = () => {
  return (
    <Row right>
      <SizedImage
        accessibilityLabel="reminder-bell"
        maxHeight={SIZES.ILLUSTRATION.SM.value}
        pixelSize={SIZES.ILLUSTRATION.SM.value}
        source={require('../images/Bell.png')}
      />
    </Row>
  );
};
